import React, { useRef, useState } from "react";
import ScrollToTop from "../../components/scroll-to-top";
import SEO from "../../components/seo";
import WoEligibilityContainer from "../../containers/career/wo-info-eligibility";
import WoInfoContainer from "../../containers/career/wo-info";
import Footer from "../../layouts/footer";
import Header from "../../layouts/header";
import Layout from "../../layouts/index";

const JobCareerForWomenPage = () => {
    const contRef = useRef(null);
    const handleScrollToHeader = () => {
        console.log("scrllheader", contRef);
        if (contRef.current) {
            console.log("scrllheader2");
            // Adjust scrolling to account for the height of the small div
            const headerPosition = contRef.current.offsetTop;
            const divHeight = 0; // Adjust this if your div's height changes
            window.scrollTo({
                top: headerPosition,
                behavior: "smooth",
            });
        }
    };
    return (
        <React.Fragment>
            <Layout>
                <SEO title="2nd Career for Women | NeoGrowth - Lending simplified. Growth amplified." />
                <div className="wrapper">
                    <Header
                        onPressSkipButton={() => {
                            handleScrollToHeader();
                        }}
                    />
                    <div className="home-banner-section position-relative">
                        <img
                            className="home-banner-shape"
                            src="/images/banner/page/woman-career.jpg"
                            alt="shape"
                        />
                    </div>

                    <WoInfoContainer
                        classOption="pb-10 pt-10"
                        contRef={contRef}
                    />

                    <WoEligibilityContainer classOption="" />

                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default JobCareerForWomenPage;
